module.exports = __webpack_public_path__ + "src/app/_content/imgs/splash/i8.jpg?ee64de8ab268f16c6f82fb5008826851";